import React, { useEffect, useState } from "react";
import {
  StyledSidebarItemsWrapper,
  StyledSidebarItems,
} from "./StyledResponsiveSidebar";
import "./ResponsiveSidebar.css";
import { Grid, Collapse } from "@material-ui/core";
import { connect } from "react-redux";

import {
  sidebarDropdownOptionsAction,
  sidebarCollapseStateAction,
  sidebarHandleOnHoverClassAction,
} from "../../../redux/CommonSidebar/CommonSidebarActions";
import {
  TitleColumnWrapper,
  TitleColumnWrapperWithStyles,
} from "../../home/DashboardStyles";
import { tokenValidation } from "../../../helper/customizedHooks";
import { clearLocalComponentData } from "../../../redux/fui";
import VPNKeyIcon from "@material-ui/icons/VpnKey";
import HomeIcon from "@material-ui/icons/Home";
import StorageIcon from "@material-ui/icons/Storage";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import HelpIcon from "@material-ui/icons/Help";
import WebIcon from "@material-ui/icons/Web";
import BarChart from "@material-ui/icons/BarChart";
import Receipt from "@material-ui/icons/List";
import AdminSettingsPanelIcon from "../../../assets/icons/AdminSettingsPanel";
import AiIcon from "../../../assets/icons/AiIcon";

const ResponsiveSidebar = ({
  currentRoute,
  sidebarDropdownOptionsAction,
  sidebarCollapseStateAction,
  sidebarDropdownStateByClick,
  sidebarCollapseFulfillmentState,
  sidebarCollapseSshManagementState,
  sidebarCollapseAccessManagementState,
  sidebarCollapseAdminState,
  sidebarCollapseServerState,
  sidebarContainerOnHoverClasses,
  sidebarHandleOnHoverClassAction,
  sidebarTextOnHoverClass,
  clearLocalComponentData,
  camPermissions,
  userDetails,
}) => {
  /**
   * The floating sidebar menu
   * @author Carlos Montes
   * @version 1.0
   * @see Used in component: CommonLayout.js
   */
  const [fulfillmentIconTransition, setFulfillmentIconTransition] = useState(
    "material-icons colorIcon"
  );
  const [sshIconTransition, setSshIconTransition] = useState(
    "material-icons colorIcon"
  );
  const [accessIconTransition, setAccessIconTransition] = useState(
    "material-icons colorIcon"
  );
  const [adminIconTransition, setAdminIconTransition] = useState(
    "material-icons colorIcon"
  );
    const [serverIconTransition, setServerIconTransition] = useState(
    "material-icons colorIcon"
  );
  const userRbac = JSON.parse(
    localStorage.getItem("userRoleBasedAccessControl")
  );
  const currentCamPermissions =
    userRbac !== null ? userRbac.data : camPermissions;

  // Check if user custom:country is 'China' to hide SSH Management
  const shouldHideSshManagement = userDetails &&
    userDetails.hasOwnProperty('custom:country') &&
    userDetails['custom:country'] === 'China';

  // Check if user custom:country is 'China' to hide New Order option
  const shouldHideNewOrder = userDetails &&
    userDetails.hasOwnProperty('custom:country') &&
    userDetails['custom:country'] === 'China';

  const handleCollapse = (selectedScreenOption) => {
    sidebarDropdownOptionsAction(selectedScreenOption);
  };

  const handleMouseEnterEvent = () => {
    let collapseFulfillmentState = sidebarDropdownStateByClick.fulfillment.isOpenTab;
    let collapseSshManagementState = sidebarDropdownStateByClick.sshManagement.isOpenTab;
    let collapseAdminState = sidebarDropdownStateByClick.admin.isOpenTab;
    let collapseServerState = sidebarDropdownStateByClick.server.isOpenTab;
    sidebarCollapseStateAction(
      collapseFulfillmentState,
      collapseSshManagementState,
      collapseAdminState,
      collapseServerState
    );
    sidebarHandleOnHoverClassAction(
      "sidebar_items_originalSize_hover",
      "showTextOnHover"
    );
  };

  const handleMouseCloseEvent = () => {
    sidebarHandleOnHoverClassAction("sidebar_items_originalSize", "text");
    sidebarCollapseStateAction(false, false);
  };

  useEffect(() => {
    if (sidebarCollapseFulfillmentState) {
      setFulfillmentIconTransition(
        "material-icons colorIcon iconTransitionOpen"
      );
    } else {
      setFulfillmentIconTransition(
        "material-icons colorIcon iconTransitionClose"
      );
    }
    if (sidebarCollapseSshManagementState) {
      setSshIconTransition("material-icons colorIcon iconTransitionOpen");
    } else {
      setSshIconTransition("material-icons colorIcon iconTransitionClose");
    }
    if (sidebarCollapseAccessManagementState) {
      setAccessIconTransition("material-icons colorIcon iconTransitionOpen");
    } else {
      setAccessIconTransition("material-icons colorIcon iconTransitionClose");
    }
    if (sidebarCollapseAdminState) {
      setAdminIconTransition("material-icons colorIcon iconTransitionOpen");
    } else {
      setAdminIconTransition("material-icons colorIcon iconTransitionClose");
    }
    if (sidebarCollapseServerState) {
      setServerIconTransition("material-icons colorIcon iconTransitionOpen");
    } else {
      setServerIconTransition("material-icons colorIcon iconTransitionClose");
    }
  }, [sidebarCollapseFulfillmentState, sidebarCollapseSshManagementState, sidebarCollapseAccessManagementState, sidebarCollapseAdminState,sidebarCollapseServerState]);

  const handleFuiTabs = () => {
    tokenValidation();
    clearLocalComponentData();
  };
  const handleServerTabs = () => {
    tokenValidation();
    clearLocalComponentData();
  };

  return (
    <div className="nav-sidebar">
      {Object.keys(currentCamPermissions).length !== 0 && (
        <StyledSidebarItemsWrapper>
          <StyledSidebarItems
            className={sidebarContainerOnHoverClasses}
            onMouseEnter={handleMouseEnterEvent}
            onMouseLeave={handleMouseCloseEvent}
            data-cy="floatingMenu"
          >
            <Grid container>
              <Grid item xs={12}>
                <Grid container className="center">
                  {/* Dashboard */}
                  <Grid
                    item
                    xs={12}
                    className="center paddingBottom rowContent"
                  >
                    <TitleColumnWrapper to="/">
                      <div className="iconsvg">
                        <HomeIcon
                          className={
                            currentRoute === "/"
                              ? `material-icons currentColorIcon`
                              : `material-icons colorIcon`
                          }
                        ></HomeIcon>
                      </div>
                    </TitleColumnWrapper>
                    <TitleColumnWrapperWithStyles
                      className={
                        currentRoute === "/"
                          ? `${sidebarTextOnHoverClass} currentRouteColor`
                          : `${sidebarTextOnHoverClass} text `
                      }
                      to="/"
                    >
                      Dashboard
                    </TitleColumnWrapperWithStyles>
                  </Grid>

                  {/* Servers */}
                  {currentCamPermissions[0].filter(
                    (permission) => permission.component === "ServerManagementComponent"
                  ).length !== 0 && (
                      <>
                        <Grid
                          item
                          xs={12}
                          className="center paddingBottom rowContent"
                          onClick={()=>handleCollapse("server")}
                        >
                          <div>
                            <StorageIcon
                              className={
                                currentRoute.includes("server")
                                  ? `material-icons currentColorIcon`
                                  : `material-icons colorIcon`
                              }
                            ></StorageIcon>
                          </div>
                          <Grid
                            container
                            className={
                              currentRoute.includes("server")
                                ? `${sidebarTextOnHoverClass} currentRouteColor`
                                : `${sidebarTextOnHoverClass} text `
                            }
                          >
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item xs={10} className="center">
                                  Server
                                </Grid>
                                <Grid item xs={2}>
                                  <ArrowDropDownIcon
                                    className={
                                      currentRoute.includes("server")
                                        ? `${fulfillmentIconTransition} currentColorIcon`
                                        : `${fulfillmentIconTransition}`
                                    }
                                  ></ArrowDropDownIcon>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Collapse
                          in={sidebarCollapseServerState}
                          timeout={300}
                          className="collapse_row_size"
                        >
                          <Grid item xs={12}>
                            <TitleColumnWrapper
                              style={{
                                position: "relative",
                                right: "-36px"
                              }}
                              onClick={handleServerTabs}
                              className={
                                currentRoute.includes("genwizard2")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/server/genwizard2"
                            >
                              Genwizard 2.0
                            </TitleColumnWrapper>
                            <TitleColumnWrapper
                              style={{
                                position: "relative",
                                right: "-36px"
                              }}
                              onClick={handleServerTabs}
                              className={
                                currentRoute.includes("genwizard4")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/server/genwizard4"
                            >
                              Genwizard 4.0
                            </TitleColumnWrapper>
                          </Grid>
                        </Collapse>
                      </>
                    )}


                  {/* Fulfillment */}
                  {currentCamPermissions[0].filter(
                    (permission) => permission.component === "FulfillmentUI"
                  ).length !== 0 && (
                      <>
                        <Grid
                          item
                          xs={12}
                          className="center paddingBottom rowContent"
                          onClick={() => handleCollapse("fulfillment")}
                        >
                          <div className="iconsvg">
                            <WebIcon
                              className={
                                currentRoute.includes("fui")
                                  ? `material-icons currentColorIcon`
                                  : `material-icons colorIcon`
                              }
                            >
                              web
                            </WebIcon>
                          </div>
                          <Grid
                            container
                            className={
                              currentRoute.includes("fui")
                                ? `${sidebarTextOnHoverClass} currentRouteColor`
                                : `${sidebarTextOnHoverClass} text `
                            }
                          >
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item xs={10} className="center">
                                  Fulfillment
                                </Grid>
                                <Grid item xs={2}>
                                  <ArrowDropDownIcon
                                    className={
                                      currentRoute.includes("fui")
                                        ? `${fulfillmentIconTransition} currentColorIcon`
                                        : `${fulfillmentIconTransition}`
                                    }
                                  ></ArrowDropDownIcon>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Collapse
                          in={sidebarCollapseFulfillmentState}
                          timeout={300}
                          className="collapse_row_size"
                        >
                          <Grid item xs={12}>
                            {!shouldHideNewOrder && (
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                onClick={handleFuiTabs}
                                className={
                                  currentRoute.includes("order")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/fui/order"
                              >
                                New Order
                              </TitleColumnWrapper>
                            )}
                            {/* <TitleColumnWrapper
                              style={{
                                position: "relative",
                                right: "-36px"
                              }}
                              onClick={handleFuiTabs}
                              className={
                                currentRoute.includes("agentmesh")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/fui/agentmesh"
                            >
                              Agent Mesh
                            </TitleColumnWrapper> */}
                            <TitleColumnWrapper
                              style={{
                                position: "relative",
                                right: "-36px"
                              }}
                              onClick={handleFuiTabs}
                              className={
                                currentRoute.includes("platforms")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/fui/platforms"
                            >
                              Platform Orders
                            </TitleColumnWrapper>
                            <TitleColumnWrapper
                              style={{
                                position: "relative",
                                right: "-36px"
                              }}
                              onClick={handleFuiTabs}
                              className={
                                currentRoute.includes("licenses")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/fui/licenses"
                            >
                              License Orders
                            </TitleColumnWrapper>
                          </Grid>
                        </Collapse>
                      </>
                    )}
                  {/* SSH Management */}
                  {currentCamPermissions[0].filter(
                    (permission) => permission.component === "Ssh"
                  ).length !== 0 && !shouldHideSshManagement && (
                      <>
                        <Grid
                          item
                          xs={12}
                          className="center paddingBottom rowContent"
                          onClick={() => handleCollapse("accessManagement")}
                        >
                          <div className="iconsvg">
                            <VPNKeyIcon
                              className={
                                currentRoute.includes("ssh")
                                  ? `material-icons currentColorIcon`
                                  : `material-icons colorIcon`
                              }
                            ></VPNKeyIcon>
                          </div>
                          <Grid
                            container
                            className={
                              currentRoute.includes("ssh")
                                ? `${sidebarTextOnHoverClass} currentRouteColor`
                                : `${sidebarTextOnHoverClass} text `
                            }
                            data-cy="expandSSHMenu"
                          >
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item xs={10} className="center">
                                  Access Management
                                </Grid>
                                <Grid item xs={2}>
                                  <ArrowDropDownIcon
                                    className={
                                      currentRoute.includes("ssh")
                                        ? `${accessIconTransition} currentColorIcon`
                                        : `${accessIconTransition}`
                                    }
                                  ></ArrowDropDownIcon>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Servers */}

                        <Collapse
                          in={sidebarCollapseAccessManagementState}
                          timeout={300}
                          className="collapse_row_size"
                        >
                          {/* <Collapse in={sidebarDropdownStateByClick.sshManagement.isOpenTab} timeout={300} className='collapse_row_size' > */}
                          <Grid item xs={12} className="subtext">
                            <TitleColumnWrapper
                              className={
                                currentRoute.includes("ssh/sshDashboard")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="#"
                            >
                              <Grid
                                item
                                xs={12}
                                className="center paddingBottom rowContent"
                                onClick={() => handleCollapse("sshManagement")}
                              >

                                <Grid
                                  container
                                  className={
                                    currentRoute.includes("ssh")
                                      ? `${sidebarTextOnHoverClass} currentRouteColor`
                                      : `${sidebarTextOnHoverClass} text `
                                  }
                                  data-cy="expandSSHMenu"
                                >
                                  <Grid item xs={12}>
                                    <Grid container>
                                      <Grid item xs={10} className="center" style={{ position: "relative", left: "20px" }}>
                                        SSH Management
                                      </Grid>
                                      <Grid item xs={2}>
                                        <ArrowDropDownIcon
                                          className={
                                            currentRoute.includes("ssh")
                                              ? `${sshIconTransition} currentColorIcon`
                                              : `${sshIconTransition}`
                                          }
                                        ></ArrowDropDownIcon>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </TitleColumnWrapper>
                            <Collapse
                              in={sidebarCollapseSshManagementState}
                              timeout={300}
                              className="collapse_row_size"
                            >
                              {/* <Collapse in={sidebarDropdownStateByClick.sshManagement.isOpenTab} timeout={300} className='collapse_row_size' > */}
                              <Grid item xs={12} className="subtext">
                                <TitleColumnWrapper
                                  style={{
                                    position: "relative",
                                    left: "46px"
                                  }}
                                  className={
                                    currentRoute.includes("ssh/sshDashboard")
                                      ? `collapse sidebar_screenOptions_size currentColorIcon`
                                      : `collapse sidebar_screenOptions_size subtext`
                                  }
                                  to="/ssh/sshDashboard"
                                >
                                  SSH Dashboard
                                </TitleColumnWrapper>
                                <TitleColumnWrapper
                                  style={{
                                    position: "relative",
                                    left: "46px"
                                  }}
                                  className={
                                    currentRoute.includes("ssh/sshUserManagement")
                                      ? `collapse sidebar_screenOptions_size currentColorIcon`
                                      : `collapse sidebar_screenOptions_size subtext`
                                  }
                                  to="/ssh/sshUserManagement"
                                  data-cy="userManagementCy"
                                >
                                  SSH User Management
                                </TitleColumnWrapper>
                                <TitleColumnWrapper
                                  style={{
                                    position: "relative",
                                    left: "46px"
                                  }}
                                  data-cy="sshArchiveCy"
                                  className={
                                    currentRoute.includes("ssh/sshArchive")
                                      ? `collapse sidebar_screenOptions_size currentColorIcon`
                                      : `collapse sidebar_screenOptions_size subtext`
                                  }
                                  to="/ssh/sshArchive"
                                >
                                  SSH Archive
                                </TitleColumnWrapper>
                              </Grid>
                            </Collapse>
                            {/* <TitleColumnWrapper
                              className={
                                currentRoute.includes("azureOpenAI")
                                  ? `collapse sidebar_screenOptions_size currentColorIcon`
                                  : `collapse sidebar_screenOptions_size subtext`
                              }
                              to="/genwizard"
                            >
                              <Grid
                                item
                                xs={12}
                                className="center paddingBottom rowContent"
                              // onClick={() => handleCollapse("sshManagement")}
                              >
                                <Grid
                                  container
                                  className={
                                    currentRoute.includes("azureOpenAI")
                                      ? `${sidebarTextOnHoverClass} currentRouteColor`
                                      : `${sidebarTextOnHoverClass} text `
                                  }
                                  data-cy="expandSSHMenu"
                                >
                                  <Grid item xs={12}>
                                    <Grid container>
                                      <Grid item xs={10} className="center" style={{ position: "relative", left: "20px" }}>
                                        Genwizard
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </TitleColumnWrapper> */}
                          </Grid>

                        </Collapse>

                      </>
                    )}

                  <Grid
                    item
                    xs={12}
                    className="center paddingBottom rowContent"
                  >
                    <TitleColumnWrapper to="/genwizard" data-cy="expandGenwizard">
                      <div className="iconsvg">
                        <AiIcon
                          className={
                            currentRoute.includes("azureOpenAI")
                              ? `material-icons currentColorIcon`
                              : `material-icons colorIcon`
                          }
                        ></AiIcon>
                      </div>
                    </TitleColumnWrapper>
                    <TitleColumnWrapperWithStyles
                      className={
                        currentRoute.includes("azureOpenAI")
                          ? `${sidebarTextOnHoverClass} currentRouteColor`
                          : `${sidebarTextOnHoverClass} text `
                      }
                      to="/genwizard"
                    >
                      AI Provider
                    </TitleColumnWrapperWithStyles>
                  </Grid>

                  {/* moorthy team */}
                  {currentCamPermissions[0].filter(
                    (permission) => (permission.component === "AdminAccess" || permission.component === "LicenseManagementAdminAccess")
                  ).length !== 0 && (
                      <Grid
                        item
                        xs={12}
                        className="center paddingBottom rowContent"
                      >
                        <TitleColumnWrapper to="/licensemanagement" data-cy="faqDashboard">
                          <div className="iconsvg">
                            <Receipt
                              className={
                                currentRoute.includes("licensemanagement")
                                  ? `material-icons currentColorIcon`
                                  : `material-icons colorIcon`
                              }
                            />
                          </div>
                        </TitleColumnWrapper>
                        <TitleColumnWrapperWithStyles
                          className={
                            currentRoute.includes("licensemanagement")
                              ? `${sidebarTextOnHoverClass} currentRouteColor`
                              : `${sidebarTextOnHoverClass} text `
                          }
                          to="/licensemanagement"
                        >
                          License Management
                        </TitleColumnWrapperWithStyles>
                      </Grid>)
                  }
                  {/* admin */}
                  {currentCamPermissions[0].filter(
                    (permission) => (permission.component === "AdminAccess" || permission.component === "LicenseManagementAdminAccess")
                  ).length !== 0 && (
                      <>
                        {/* metrics */}
                        {/* <Grid
                          item
                          xs={12}
                          className="center paddingBottom rowContent"
                        >
                          <TitleColumnWrapper to="/metrics" data-cy="faqDashboard">
                            <div className="iconsvg">
                              <BarChart
                                className={
                                  currentRoute.includes("metrics")
                                    ? `material-icons currentColorIcon`
                                    : `material-icons colorIcon`
                                }
                              ></BarChart>
                            </div>
                          </TitleColumnWrapper>
                          <TitleColumnWrapperWithStyles
                            className={
                              currentRoute.includes("metrics")
                                ? `${sidebarTextOnHoverClass} currentRouteColor`
                                : `${sidebarTextOnHoverClass} text `
                            }
                            to="/metrics"
                          >
                            Metrics
                          </TitleColumnWrapperWithStyles>
                        </Grid> */}
                        {/* admin menu */}
                        <Grid
                          item
                          xs={12}
                          className="center paddingBottom rowContent"
                          onClick={() => handleCollapse("admin")}
                        >
                          <div className="iconsvg">
                            <AdminSettingsPanelIcon
                              className={
                                currentRoute.includes("admin")
                                  ? `material-icons currentColorIcon`
                                  : `material-icons colorIcon`
                              }
                            >
                            </AdminSettingsPanelIcon>
                          </div>
                          <Grid
                            container
                            className={
                              currentRoute.includes("admin")
                                ? `${sidebarTextOnHoverClass} currentRouteColor`
                                : `${sidebarTextOnHoverClass} text `
                            }
                          >
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item xs={10} className="center">
                                  Admin
                                </Grid>
                                <Grid item xs={2}>
                                  <ArrowDropDownIcon
                                    className={
                                      currentRoute.includes("admin")
                                        ? `${adminIconTransition} currentColorIcon`
                                        : `${adminIconTransition}`
                                    }
                                  ></ArrowDropDownIcon>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Collapse
                          in={sidebarCollapseAdminState}
                          timeout={300}
                          className="collapse_row_size"
                        >
                          <Grid item xs={12}>
                            {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&


                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                // onClick={handleFuiTabs}
                                className={
                                  currentRoute.includes("admin/adminAuthControl")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/adminAuthControl"
                              >
                                Authorization Control
                              </TitleColumnWrapper>
                            }
                            {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                // onClick={handleFuiTabs}
                                className={
                                  currentRoute.includes("admin/adminOrderHandling")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/adminOrderHandling"
                              >
                                Order Handling
                              </TitleColumnWrapper>
                            }
                            {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                // onClick={handleFuiTabs}
                                className={
                                  currentRoute.includes("admin/adminOrderFollowup")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/adminOrderFollowup"
                              >
                                Order Follow Up
                              </TitleColumnWrapper>
                            }
                            {/* {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                // onClick={handleFuiTabs}
                                className={
                                  currentRoute.includes("admin/adminKeyManagement")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/adminKeyManagement"
                              >
                                Key Management & Rotation
                              </TitleColumnWrapper>
                            } */}
                            {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                className={
                                  currentRoute.includes("admin/adminOpenAipage")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/adminOpenAipage"
                              >
                                OpenAi
                              </TitleColumnWrapper>
                            }
                            {/* {currentCamPermissions[0].some(
                              permission => permission.component === "Admin"
                            ) &&
                              <TitleColumnWrapper
                                style={{
                                  position: "relative",
                                  right: "-36px"
                                }}
                                className={
                                  currentRoute.includes("admin/sso-requests")
                                    ? `collapse sidebar_screenOptions_size currentColorIcon`
                                    : `collapse sidebar_screenOptions_size subtext`
                                }
                                to="/admin/sso-requests"
                              >
                                Client SSO Requests
                              </TitleColumnWrapper>
                            } */}
                          </Grid>
                        </Collapse>
                      </>
                    )}

                  <Grid
                    item
                    xs={12}
                    className="center paddingBottom rowContent"
                  >
                    <TitleColumnWrapper to="/faq" data-cy="faqDashboard">
                      <div className="iconsvg">
                        <HelpIcon
                          className={
                            currentRoute.includes("faq")
                              ? `material-icons currentColorIcon`
                              : `material-icons colorIcon`
                          }
                        ></HelpIcon>
                      </div>
                    </TitleColumnWrapper>
                    <TitleColumnWrapperWithStyles
                      className={
                        currentRoute.includes("faq")
                          ? `${sidebarTextOnHoverClass} currentRouteColor`
                          : `${sidebarTextOnHoverClass} text `
                      }
                      to="/faq"
                    >
                      FAQ
                    </TitleColumnWrapperWithStyles>
                  </Grid>

                  {/* {currentCamPermissions[0].filter(
                  (permission) => permission.component === "Admin"
                ).length !== 0 && (
                    <Grid
                      item
                      xs={12}
                      className="center paddingBottom rowContent"
                    >
                      <TitleColumnWrapper to="/admin" data-cy="adminPage">
                        <div>
                          <AdminSettingsPanelIcon
                            className={
                              currentRoute.includes("admin")
                                ? `material-icons currentColorIcon`
                                : `material-icons colorIcon`
                            }
                          ></AdminSettingsPanelIcon>
                        </div>
                      </TitleColumnWrapper>
                      <TitleColumnWrapperWithStyles
                        className={
                          currentRoute.includes("admin")
                            ? `${sidebarTextOnHoverClass} currentRouteColor`
                            : `${sidebarTextOnHoverClass} text `
                        }
                        to="/admin"
                      >
                        Admin
                      </TitleColumnWrapperWithStyles>
                    </Grid>
                  )} */}
                </Grid>
                {/* <Divider /> */}
              </Grid>
            </Grid>
          </StyledSidebarItems>
        </StyledSidebarItemsWrapper>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  username: state.auth.userDetails.email
    ? state.auth.userDetails.email
      .replace(/@[^@]+$/, "")
      .replace(".", " ")
      .split(" ")
      .map(function (item) {
        return item[0];
      })
      .join("")
      .toUpperCase()
    : "",
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  userDetails: state.auth.userDetails,
  sidebarDropdownStateByClick: state.sidebarReducer.sidebarDropdownStateByClick,
  sidebarCollapseFulfillmentState:state.sidebarReducer.sidebarCollapseFulfillmentState,
  sidebarCollapseSshManagementState:state.sidebarReducer.sidebarCollapseSshManagementState,
  sidebarCollapseAccessManagementState: state.sidebarReducer.sidebarCollapseAccessManagementState,
  sidebarCollapseAdminState: state.sidebarReducer.sidebarCollapseAdminState,
  sidebarCollapseServerState: state.sidebarReducer.sidebarCollapseServerState,
  sidebarContainerOnHoverClasses:state.sidebarReducer.sidebarContainerOnHoverClasses,
  sidebarTextOnHoverClass: state.sidebarReducer.sidebarTextOnHoverClass,
  camPermissions: state.auth.camPermissions,
});

export default connect(mapStateToProps, {
  sidebarDropdownOptionsAction,
  sidebarCollapseStateAction,
  sidebarHandleOnHoverClassAction,
  clearLocalComponentData,
})(ResponsiveSidebar);
